import { render, staticRenderFns } from "./claimsList.vue?vue&type=template&id=f7b284d8"
import script from "./claimsList.vue?vue&type=script&lang=js"
export * from "./claimsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports